import { useEffect, useMemo, useState } from "react";
import { getRecentCarts } from "../services/cartService";
import { getUserById } from "../services/userService";
import { Cart } from "../types/Cart";
import { VCDBUser } from "../types/VCDBUser";

export function useAdminRecentCarts() {
  const [carts, setCarts] = useState<Cart[]>([]);
  const [cartUserMap, setCartUserMap] = useState<Map<string, VCDBUser>>(
    new Map(),
  );
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCarts = async () => {
      try {
        const carts = await getRecentCarts();
        setCarts(carts);

        const cartUserMap = new Map<string, VCDBUser>();
        for (const cart of carts) {
          if (cart.creatorUserId) {
            const user = await getUserById(cart.creatorUserId);
            cartUserMap.set(cart.creatorUserId, user);
          }
        }
        setCartUserMap(cartUserMap);
        setIsLoading(false);
      } catch (error) {
        setError(error as string);
      }
    };

    fetchCarts();
  }, []);

  return useMemo(() => {
    return { carts, cartUserMap, isLoading, error };
  }, [carts, cartUserMap, isLoading, error]);
}
